import { useEffect } from "react";
import { Col, Row, Typography, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import CustomInput from "../../components/CustomInput/Input";
import { entNameRules, tenureRules } from "../../helpers/helpers";
import CustomButton from "../../components/CustomButton/Button";
import { BTN_TXT } from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import { getInvDropdown } from "../../redux/slices/InvoiceuploadSlice";
import {
  DEAL_CATEGORY_IDS,
  isSupplyChainCategory,
} from "../../helpers/dealCategoryProducts";
import "./InvoiceUpload.scss";

const { Title } = Typography;

const InvoiceUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { entList } = useSelector((state) => state?.invoiceUpload || {});
  const activeCategory = useSelector((state) => state?.dealCategory?.activeCategory);
  const user = useSelector((state) => state?.auth?.user);
  const currentDealCategoryId =
    activeCategory?.dealCategoryId ||
    user?.dealCategories?.[0]?.dealCategoryId ||
    DEAL_CATEGORY_IDS.INVOICE_FINANCING;
  const isSupplyChain = isSupplyChainCategory(currentDealCategoryId);

  useEffect(() => {
    if (isSupplyChain) {
      navigate("/supply-chain-upload", { replace: true });
    }
  }, [isSupplyChain, navigate]);

  useEffect(() => {
    dispatch(getInvDropdown(DEAL_CATEGORY_IDS.INVOICE_FINANCING));
  }, [dispatch]);

  const handleUploadInvoice = (values) => {
    const selectedEnt = entList.find(
      (item) => item.busEntId === values.entName
    );

    if (!selectedEnt) {
      return;
    }


    navigate("/upload-inv-files", {
      state: {
        selectedEnt,
        selectedBusEntId: values.entName,
        tenure: values.tenure,
        dealCategoryId: DEAL_CATEGORY_IDS.INVOICE_FINANCING,
      },
    });
  };

  return (
    <>
      <Title level={3} style={{ margin: 0, fontSize: 24 }}>
        Invoice Upload
      </Title>
      <Form
        layout="vertical"
        onFinish={handleUploadInvoice}
        initialValues={{ remember: true }}
        className="invoice-upload-form"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={10}>
            <CustomSelect
              label="Enterprise Name"
              name="entName"
              showSearch
              placeholder="Select Enterprise"
              className="custom-ent-select"
              options={entList.map((item) => ({
                value: item.busEntId,
                label: item.entName,
              }))}
              rules={entNameRules}
            />
          </Col>
          <Col xs={24} md={10}>
            <CustomInput
              label="Tenure"
              name="tenure"
              type="text"
              placeholder="Enter Tenure (Min 30 Days - Max 90 Days)"
              rules={tenureRules}
            />
          </Col>
          <Col xs={24} md={4}>
            <Form.Item>
              <CustomButton
                type="primary"
                htmlType="submit"
                block
                style={{ padding: 24, marginTop: 32 }}
              >
                {BTN_TXT.UPLOAD_INV}
              </CustomButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default InvoiceUpload;
